var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512.00025",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m75 512c-3.835938 0-7.675781-1.464844-10.605469-4.394531-5.859375-5.859375-5.859375-15.351563 0-21.210938l30-30c5.859375-5.859375 15.351563-5.859375 21.210938 0s5.859375 15.351563 0 21.210938l-30 30c-2.929688 2.929687-6.765625 4.394531-10.605469 4.394531zm0 0",
    fill: "#465a61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m437 512c-3.835938 0-7.675781-1.464844-10.605469-4.394531l-30-30c-5.859375-5.859375-5.859375-15.351563 0-21.210938s15.351563-5.859375 21.210938 0l30 30c5.859375 5.859375 5.859375 15.351563 0 21.210938-2.929688 2.929687-6.765625 4.394531-10.605469 4.394531zm0 0",
    fill: "#3b4a51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m326.5 25.5-90 90c-2.699219 3-6.601562 4.5-10.5 4.5s-7.800781-1.5-10.5-4.5l-90-90c-6-5.699219-6-15.300781 0-21 5.699219-6 15.300781-6 21 0l79.5 79.199219s0 0 .300781-.300781l79.199219-78.898438c5.699219-6 15.296875-6 21 0 6 5.699219 6 15.300781 0 21zm0 0",
    fill: "#465a61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m236.5 115.5c-2.699219 3-6.601562 4.5-10.5 4.5v-36.300781s0 0 .300781-.300781l79.199219-78.898438c5.699219-6 15.296875-6 21 0 6 5.699219 6 15.300781 0 21zm0 0",
    fill: "#3b4a51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m467 90h-422c-24.902344 0-45 20.097656-45 45v302c0 24.898438 20.097656 45 45 45h422c24.902344 0 45-20.101562 45-45v-302c0-24.902344-20.097656-45-45-45zm0 0",
    fill: "#e63950"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m512 135v302c0 24.898438-20.097656 45-45 45h-241v-392h241c24.902344 0 45 20.097656 45 45zm0 0",
    fill: "#cc2e43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m317 150h-212c-24.902344 0-45 20.097656-45 45v182c0 24.898438 20.097656 45 45 45h212c24.902344 0 45-20.101562 45-45v-182c0-24.902344-20.097656-45-45-45zm0 0",
    fill: "#c6e2e7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m422 225c-16.539062 0-30-13.460938-30-30s13.460938-30 30-30 30 13.460938 30 30-13.460938 30-30 30zm0 0",
    fill: "#c6e2e7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#465a61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m437 285h-30c-8.289062 0-15-6.707031-15-15 0-8.289062 6.710938-15 15-15h30c8.292969 0 15 6.710938 15 15 0 8.292969-6.707031 15-15 15zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437 347h-30c-8.289062 0-15-6.707031-15-15 0-8.289062 6.710938-15 15-15h30c8.292969 0 15 6.710938 15 15 0 8.292969-6.707031 15-15 15zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437 407h-30c-8.289062 0-15-6.707031-15-15 0-8.289062 6.710938-15 15-15h30c8.292969 0 15 6.710938 15 15 0 8.292969-6.707031 15-15 15zm0 0"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m362 195v182c0 24.898438-20.097656 45-45 45h-91v-272h91c24.902344 0 45 20.097656 45 45zm0 0",
    fill: "#a8d3d8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.60d7380f2903d2769fc0d90b4c83f9a6.svg";
export { ForwardRef as ReactComponent };